/* Backend enum mirrors. Must stay in sync with backend/app/models/enums.py
 * and the seed/regions.yaml slugs — drift is caught at runtime by 422 on
 * /resume/calculate, but we keep them aligned to avoid surprises. */

export const Experience = Object.freeze({
  LT1: 'lt1',
  Y1_3: 'y1_3',
  Y3_5: 'y3_5',
  Y5_10: 'y5_10',
  GT10: 'gt10',
});

export const EnglishLevel = Object.freeze({
  NONE: 'none',
  A1: 'a1',
  A2: 'a2',
  B1: 'b1',
  B2: 'b2',
  C1: 'c1',
  C2: 'c2',
});

// Foreign languages user can attach to their resume. Mirror of
// backend/app/models/enums.py:Language.
export const Language = Object.freeze({
  EN: 'en',
  DE: 'de',
  FR: 'fr',
  ES: 'es',
  IT: 'it',
  ZH: 'zh',
  JA: 'ja',
});

// Common region slugs from backend/seed/regions.yaml. Frontend should always
// pull the full catalog via /catalogs/regions; these are just for defaults
// and code references.
export const Region = Object.freeze({
  MSK: 'msk',
});

// Display labels for role categories. Keys mirror backend
// app/services/catalog_seed.py:ROLE_CATEGORY_ORDER. An unknown/new category
// falls through to «Другое» in the role-picker.
export const ROLE_CATEGORY_LABELS = Object.freeze({
  engineering: 'Разработка и инженерия',
  product: 'Продукт и аналитика',
  leadership: 'Поддержка и руководство',
});

// Human labels for the predictor slugs we may see in
// CalculationOut.predictor_version. Unknown slug (e.g. a future predictor
// the frontend hasn't been taught about yet) falls back to the slug itself
// so we still display *something* honest.
export const PREDICTOR_LABELS = Object.freeze({
  'mock-v1': 'Mock',
  'ml-catboost-v1': 'CatBoost v1',
  'ml-catboost-v2-midwidth': 'CatBoost v2 (mid+width)',
});

export function predictorLabel(slug) {
  return PREDICTOR_LABELS[slug] || slug || '—';
}
